import { PortalRequest as request } from "@/utils/request";
// 我的评论列表
export const getCommentList = (params, data) => {
  return request({
    url: "/user-biz/comment/list",
    method: "post",
    params,
    data,
  });
};
// 删除我的评论
export const getCommentDelete = (id) => {
  return request({
    url: `/user-biz/comment/${id}/delete`,
    method: "delete",
  });
};
// 我的反馈列表
export const getFeedbackList = (params, data) => {
  return request({
    url: "/user-biz/feedback/list",
    method: "post",
    params,
    data,
  });
};
// 新增反馈
export const createFeedback = (data) => {
  return request({
    url: "/user-biz/feedback/create",
    method: "post",
    data,
  });
};
